
    const faqHeaders = document.querySelectorAll('.faq-que-div-header');

    faqHeaders.forEach((header) => {
      header.addEventListener('click', function () {
        const content = this.nextElementSibling;
        this.classList.toggle('active');

        // Toggle the content visibility
        if (content.style.display === 'block') {
          content.style.display = 'none';
        } else {
          content.style.display = 'block';
        }
      });
    });
 